<app-header></app-header>
<router-outlet></router-outlet>
<app-loader></app-loader>
